"use strict";

import Util from "/js/util/util.js";
import AppUtil from "/js/util/app-util.js";
import CardViewUtil from "/js/card-views/card-view-util.js";

/**
 * Owns, manages and displays a stack of cards.
 */
export default class StackView {

  #$el = $('<div/>', { 'class':'stack' });

  #cards = [];
  #index = 0;
  #isFirstShow = true;

  constructor(data) {

    data.cards.forEach((item, i) => {
      const card = CardViewUtil.makeCardView(item);
      this.#cards.push(card);
      this.#$el.append(card.$el);
      // also set z-index to be in reverse order
      const z = data.cards.length - i;
      card.$el.css("z-index", z);
    });

    this.setIndex(0);
  }

  get $el() {
    return this.#$el;
  }

  get index() {
    return this.#index;
  }

  get cards() {
    return this.#cards;
  }

  get currentCard() {
    if (this.#index === -1) {
      return null;
    }
    return this.#cards[this.#index];
  }

  /** Note that actual animate-in movement is handled by CardsHolderView. */
  show() {
    this.#$el.addClass("isCurrent");
    if (this.#isFirstShow) {
      this.#isFirstShow = false;
      this.#cards.forEach((item) => { item.onFirstShow(); });
    }
  }

  /** Note that actual animate-out movement is handled by CardsHolderView. */
  hide() {
    this.#$el.removeClass("isCurrent");
  }

  /** When now is true, the css transition will be bypassed. */
  setIndex(i, now=false, isAlreadyDismissed=false) {

    this.#index = i;

    // TODO: this is hard to follow. try to make nicer.
    const go = () => {

      const applyToCard = (card, index) => {

        const updateCard = () => {
          // Update class
          card.$el.removeClass("posNo pos0 pos1 pos2 pos3 pos4 pos5 pos6 pos7 pos8 pos9");
          card.$el.addClass(cls);
          // Reset any transform that may have been applied during a user drag operation.
          Util.setTransform(card.$el, "");
          // Tell card whether it is on top or not
          card.isActive = (cls === "pos0");
        };

        let cls;
        if (index < this.#index) {
          // Is "off screen".
          cls = "posNo";
        } else {
          const ordinal = index - this.#index;
          cls = "pos" + ordinal;
        }

        const wasTopCard = card.$el.hasClass("pos0");
        const dontUseTransition = (isAlreadyDismissed && wasTopCard);
        if (dontUseTransition) {
          AppUtil.setCssWithoutTransition(card.$el, () => {
            updateCard();
          });
        } else {
          updateCard();
        }
      };

      $(this.$el.trigger("lesson-disable-and-enable-navigation"));

      this.#cards.forEach(applyToCard);
    };

    if (!now) {
      go();
    } else {
      AppUtil.setCssWithoutTransition(this.#$el.find(".card"), () => { go(); });
    }
  }

  setIndexToLast(now=false) {
    this.setIndex(this.#cards.length - 1, now);
  }

  get isAtFirstCard() {
    return this.#index === 0;
  }

  get isAtLastCard() {
    return this.#index === this.#cards.length - 1;
  }

  get length() {
    return this.#cards.length;
  }

  doNextCard(now=false, isAlreadyDismissed=false) {
    if (this.isAtLastCard) {
      return;
    }
    this.setIndex(this.#index + 1, now, isAlreadyDismissed);
  };

  doPreviousCard(now=false) {
    if (this.isAtFirstCard) {
      return;
    }

    // Clear transform of previous card before it gets animated in:
    const $previousCard = this.#cards[this.#index - 1].$el;
    AppUtil.setCssWithoutTransition($previousCard, () => $previousCard.css("transform", ""));

    this.setIndex(this.#index - 1, now);
  }
}
